'use client';

import { PropsWithChildren, useState } from 'react';

import { ArticleCategory } from '~types/Article.types';

import { CategoryContext } from './CategoryContext';

export const CategoryProvider = ({ children }: PropsWithChildren) => {
  const [category, setCategory] = useState<ArticleCategory | undefined>(
    undefined,
  );

  return (
    <CategoryContext.Provider value={{ category, setCategory }}>
      {children}
    </CategoryContext.Provider>
  );
};
